import { map, Observable } from 'rxjs';

import { ActivityFacade, ActivityStatus, IStateEvent, Transition } from '@contact/upgrade';

const MODULE_NAME = 'activityStatusDeprecatedService';

/**
 * @deprecated prefer ActivityFacade
 */
export interface IActivityStatusDeprecatedService {
  /**
   * @deprecated prefer ActivityFacade.transitionCreated$
   */
  created(): Observable<IStateEvent<ActivityStatus>>;

  /**
   * @deprecated prefer ActivityFacade.transitionSuccess$
   */
  success(): Observable<IStateEvent<ActivityStatus>>;

  /**
   * @deprecated prefer ActivityFacade.transitionFailure$
   */
  failure(): Observable<IStateEvent<ActivityStatus>>;
}

/**
 * @deprecated prefer ActivityFacade
 */
export class ActivityStatusDeprecatedService implements IActivityStatusDeprecatedService {
  static $inject: Array<string> = ['activityFacade'];

  public name = MODULE_NAME;

  constructor(private readonly activityFacade: ActivityFacade) {}

  /**
   * @deprecated prefer ActivityFacade.transitionCreated$
   */
  created() {
    return this.activityFacade.created$.pipe(map(transition => this.toEvent(transition)));
  }

  /**
   * @deprecated prefer ActivityFacade.transitionSuccess$
   */
  success() {
    return this.activityFacade.success$.pipe(map(transition => this.toEvent(transition)));
  }

  /**
   * @deprecated prefer ActivityFacade.transitionFailure$
   */
  failure() {
    return this.activityFacade.failure$.pipe(
      map(transition => ({
        ...transition,
        current: transition.error!,
      })),
      map(transition => this.toEvent(transition))
    );
  }

  private toEvent({ id, date, previous, current }: Transition): IStateEvent<ActivityStatus> {
    return {
      id,
      timestamp: new Date(date),
      oldState: previous && ActivityStatus[previous],
      newState: current && ActivityStatus[current],
    };
  }
}

export default MODULE_NAME;
